export class ApiError extends Error {
  readonly code: number | null;
  readonly type: string | null;
  readonly status: number | null;

  constructor({
    message,
    code,
    type,
    status,
  }: {
    message: string;
    status?: number;
    code?: number | null;
    type?: string | null;
  }) {
    super(message);
    this.status = status ?? null;
    this.name = 'ApiError';
    this.code = code ?? null;
    this.type = type ?? null;
  }
}
